import http from 'hub-http/clients/apiClient';
const URL = 'content-embed/v1/embed';
const EMBED_FETCH_LIMIT = 10;
const fetchAllEmbeds = async (currentEmbeds = [], offset = 0, hasSectionsLibraryAccess = false, search) => {
  const {
    embedData,
    totalCount
  } = await http.get(`${URL}/data`, {
    query: {
      limit: EMBED_FETCH_LIMIT,
      offset,
      sortBy: hasSectionsLibraryAccess ? 'NAME' : undefined,
      search
    }
  });
  const embeds = currentEmbeds.concat(embedData);
  if (totalCount > embeds.length) {
    return fetchAllEmbeds(embeds, offset + EMBED_FETCH_LIMIT, hasSectionsLibraryAccess, search);
  }
  return {
    embedData: embeds,
    totalCount
  };
};
export function fetchEmbeds(hasSectionsLibraryAccess, search) {
  return fetchAllEmbeds(undefined, undefined, hasSectionsLibraryAccess, search);
}